import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from './../Glob';
import BaseStore from '../../../../_common/platform/ts/BaseStore';
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import { apiCall } from '../../../../_common/platform/ts/AqlUtility';
import { Constants } from '../../../../_common/platform/ts/Constants';

import { config } from '../config';

import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';
import { Action, AppActions, I, check as checkAction } from '../actions/AppActions';
import { ITreeItemGeneral } from '../../../../_common/platform/ts/Interfaces';

export interface IFieldsDict {
    [key: string]: {
        module: string;
        validators?: {
            module: string;
            path: string;
            args;
        }[];
        _default;

        options;
        directOptions?;
    };
}

export interface IElement {
    id: string;
    type: string;
    title?: string;
    text?: string;
    inline?: boolean;
    inlineFixed?: boolean;
    description?: string;
}

export interface ISectionDict {
    [id: string]: {
        elements: IElement[];
    };
}

export interface ISettings {
    settings: { [id: string]: any };
    errors: { [id: string]: any };

    sectionsTree: ITreeItemGeneral[];
    sectionsDict: ISectionDict;

    fieldsDict: IFieldsDict;

    loading: boolean;
    saving: boolean;
    descriptionLoading: boolean;
    defaultThemeloading: boolean;
}

export interface ISettingsState {
    user: ISettings;
    app: ISettings;
}

//const APP_SETTINGS_DESCRIPTION_FIELD = 'settingsdescription';
const APP_SETTINGS_DEFAULT_THEME_FIELD = 'theme/default';
const APP_SETTINGS_LOGO = 'GUI/Application Logo';
const APP_SETTINGS_LOGO_POSITION = 'GUI/Application Logo Position';
const DEFAULT_WORKSPACE_SETTING = 'workspace/default';
const MOBILE_SINGLE_WORKSPACE = 'workspace/mobile_single';
const MENU_ORIENTATION = 'custommenu/orientation';
const USE_TABS = 'custommenu/usetabs';
const TOKEN_REFRESH_INTERVAL = 'Authentication/TOKEN_REFRESH_INTERVAL';

export module DefaultWorkspace {
    export interface Value {
        dir: number;
        workspace: number | MultipleWorkspaces;
        workspaceOrder?: MultipleWorkspacesOrder;
        main: string;
    }

    export interface MultipleWorkspaces {
        [id: string]: string;
    }

    export interface MultipleWorkspacesOrder {
        [id: string]: number;
    }
}

module SettingsDescription {
    // Right now only two types of blocks (elements)
    // are supported: 'label' and 'parameter'.

    type LabelElement = {
        type: 'label';

        text: string; // this is specific to 'label' element and defines displayed text
    };

    // An email which explains layout feature

    // Subject: Re: What are our possibilities to make Settings look nice?
    // From: Taras Yevtushenko <Taras.Yevtushenko@pdc.dk>
    // Date: Thu, 22 Oct 2015 13:54:58 +0200
    // CC: Leo Schou-Jensen <leo@pdc.dk>, trackDBdevelop <trackDBdevelop@pdc.dk>
    // To: Alexander Gostintsev <alexander.gostintsev@pdc.spb.su>

    // Alexander,

    // Each object in “sections” has “elements”, it defines an ordered list of elements to display for selected section.
    // There are only  two types of elements right now: parameter and label.
    // Elements are rendered as blocks from top to bottom – the usual HTML block elements flow, and there’s no way to configure it.

    // The one-line layout is implemented inside “parameter” elements, which are actually <ParameterField> React components.
    // It’s enabled by some additional fields in sections[].elements[], here’s an example:
    //         {
    //             "id": "Authentication/PWMinLength",
    //             "type": "parameter",

    //             // This will render title
    //             "title": "Password minimal length",

    //             // This enables inline layout
    //             // and title block will be 200px wide
    //             "inlineFixed": 200,

    //             // This enables description block on the right
    //             "description": "Passowrd should contain at least specified number of characters"
    //         },

    // You can see that I moved title information to “parameter” element
    // (it was previously specified as “text” field of separate “label” element, which should be removed now).

    // For Booleans we should also include “title” and remove related “label” elements.
    // And additionally we should explicitly set “noTitle: true” for related component configuration in fields[]:
    //         "Authentication/AdminCanEnterPW": {
    //             "_default": "null",
    //             "id": "Authentication/AdminCanEnterPW",
    //             "module": "_common/platform/ts/BooleanField",

    //             // Explicitly set "noTitle",
    //             // otherwise it will be rendered
    //             // (we don't need it because BooleanField renders own title on
    //             // the right of checkbox)
    //             "options": {
    //                 noTitle: true
    //             },
    //             "validators": []
    //         },

    // sections[].elements[]:
    //         {
    //             "id": "Authentication/UseEmailAsLogin",
    //             "type": "parameter",
    //             "title": "Email as Login"
    //         },

    // /Taras

    // This renders an edit parameter
    type ParameterElement = {
        type: 'parameter';
        // this is specific to 'parameter' element
        // and it should match an id of one of settings in "fields"
        id: string;
        title: string; // This will render title
        // This enables inline layout
        // and title block will be 200px wide
        inlineFixed: number;
        // This enables description block on the right
        description: string;
    };

    type Element = LabelElement | ParameterElement;

    export interface Section {
        id: string; // "id" is used internally, should be unique for each section
        name: string; // A title, used in presentation
        elements: Element[]; // A list of blocks, rendered when a section is selected
        children: Section[]; // inner nodes list
    }

    // Email to Alexander which introduces validation feature
    //
    // Date: Fri, 25 Sep 2015 10:32:25 +0200
    // Delivered-To: taras.evt@gmail.com
    // Subject: Re: Remember we need to validate Settings both in Frontend and Bckend...
    // From: Yevtushenko Taras <taras.evt@gmail.com>
    // To: Alexander Gostintsev <alexander.gostintsev@pdc.spb.su>
    // Cc: Leo Schou-Jensen <leo@pdc.dk>, trackDBdevelop <trackDBdevelop@pdc.dk>
    //
    // Hi Alexander,
    //
    // You can now specify client-side validators in settings description:
    //
    //                 "AQL/MinCacheTime": {
    //                     "_default": 86400,
    //                     "id": "AQL/MinCacheTime",
    //                     "module": "_common/platform/ts/NumberField",
    //                     "options": {},
    //
    //                     // This field is optional
    //                     "validators": [
    //                         {
    //                             // A name of validators module,
    //                             // registered with validatorsDispatcher.registerModule(...)
    //                             "module": "main",
    //
    //                             // A path to validator function in specified module
    //                             "path": "number.range",
    //
    //                             // Optional list of arguments, in case a specified function
    //                             // is a factory of validators
    //                             "args": [
    //                                 0,
    //                                 10000
    //                             ]
    //                         }
    //                     ]
    //                 },
    //
    // I implemented a new module '_common/platform/ts/validatorsDispatcher', and all validators collection modules should register themselves there upon initialization.
    // At the moment we have a built -in platform validators collection, which is registered by the name "main", the source code is here:
    // http://10.117.3.210/root/pdc-platform/blob/master/_common/platform/ts/validators.ts
    // In the example above I set number.range validator for "AQL/MinCacheTime" setting.
    // If a list of "args" is provided, it's assumed that specified function isn't a validator itself, but a factory of validators.
    // In this example, the result validator is constructed by calling number.range(0, 10000)
    //
    // /Taras
    export interface Validator {
        // A name of validators module,
        // registered with validatorsDispatcher.registerModule(...)
        // At the moment we have a built-in platform validators collection, which is registered by the name "main", the source code is here:
        // _common/platform/ts/validators.ts
        module: string;

        path: string; // A path to validator function in specified module

        // Optional list of arguments, in case a specified function
        // is a factory
        args: any[];
    }

    export interface Field {
        _default: string; // default value for field, used initially
        id: string; // This should match dictionary key in "fields"

        // Platform's JS module, which will be used to render
        // edit component
        module: string;

        options: any; // this object is passed to edit component as this.props.options
        directOptions: any; // this is available in edit components as this.props

        // This field is optional
        validators: Validator[];
    }

    export interface APIResponse {
        // A specification for settings
        fields: {
            // This key and 'id' in Field shoudld match
            [id: string]: Field;
        };

        // "sections" is a tree structure for settings sections
        // it's a list of top-level nodes, and each node has "children"
        // field which is a list of nodes itself
        sections: Section[];
    }
}

export class SettingsStore extends BaseStore<ISettingsState, AppActions, Dispatcher, IGlob> {
    public static _name = 'app-settings';

    constructor(glob, dispatcher: Dispatcher, actions: AppActions) {
        super(glob, dispatcher, actions, SettingsStore._name);

        this._state = _.extend(SettingsStore.getInitialState(), this._state);
    }

    static get(glob, dispatcher: Dispatcher, actions: AppActions) {
        return new SettingsStore(glob, dispatcher, actions);
    }

    public static getEmptySettings(settings?) {
        return {
            settings: settings || {},
            errors: {},

            sectionsTree: [],
            sectionsDict: {},

            fieldsDict: {},

            loading: false,
            saving: false,
            descriptionLoading: false,
            defaultThemeloading: false
        };
    }

    // This is needed for not unintentionally owerride it in config.
    public static getInitialAppSettings() {
        return config.INITIAL_APP_SETTINGS != null ? $.extend(true, {}, config.INITIAL_APP_SETTINGS) : null;
    }

    public static getInitialState() {
        return {
            user: SettingsStore.getEmptySettings(),
            app: SettingsStore.getEmptySettings(SettingsStore.getInitialAppSettings())
        };
    }

    public getDefaultWorkspace() {
        const obj = this.getDefaultWorkspaceValue();

        return (obj && obj.workspace) || null;
    }

    public getTokenRefreshInterval() {
        return this.getAppSetting(TOKEN_REFRESH_INTERVAL);
    }

    public getDefaultWorkspaceValue() {
        let obj: DefaultWorkspace.Value;

        if (config.SINGLE_WORKSPACE != null) {
            const mobile_single_ws = this.getAppSetting(MOBILE_SINGLE_WORKSPACE) || config.SINGLE_WORKSPACE;
            const ws = {};

            ws[mobile_single_ws] = true;

            obj = {
                main: mobile_single_ws,
                workspace: ws,
                dir: null
            };
        } else {
            obj = this.getAppSetting(DEFAULT_WORKSPACE_SETTING);
        }

        return obj;
    }

    public workspaceIsDefault(workspaceID: number) {
        const defaultWorkspaceDescription = this.getDefaultWorkspaceValue();

        if (defaultWorkspaceDescription == null) {
            return false;
        }

        const workspace = defaultWorkspaceDescription.workspace;

        if (workspace == null) {
            return false;
        } else if (typeof workspace === 'number') {
            return workspace === workspaceID;
        } else {
            return workspace[workspaceID] != null;
        }
    }

    public getAppSetting(key: string) {
        return this._state.app.settings[key];
    }

    public getApplicationLogo(): string {
        return this._state.app.settings[APP_SETTINGS_LOGO];
    }

    public getApplicationLogoPosition(): 'left' | 'leftFullHeight' | 'above' | 'noshow' {
        return this._state.app.settings[APP_SETTINGS_LOGO_POSITION];
    }

    public getMenuOrientation(): string {
        const obj = this._state.app.settings[MENU_ORIENTATION];

        if (obj != null) {
            return obj['menuorientation'];
        }

        return;
    }

    public useTabsMode(): boolean {
        const useTabs = this._state.app.settings[USE_TABS];

        return useTabs !== false;
    }

    public serializeDataToStore(data: ISettingsState): string {
        //obj = _.pick(data, 'user'); //It does not make strict type checking.
        const obj: ISettingsState = {
            user: data.user,
            app: undefined
        };

        return JSON.stringify(obj, appTheme.serializeReplacer('themeData'));
    }

    public deserializeStoredData(str: string) {
        var res: any;

        try {
            res = JSON.parse(str, appTheme.deserializeReviver('themeData', this.glob));
        } catch (e) {
            res = {};
        }

        return res;
    }

    public readSavedState() {
        if (this.name == null || this.glob.AppStore == null) {
            return;
        }

        const str = this.glob.AppStore.getFromLocalStorage(this.getStorageCacheKey());

        let deserializedObj;

        if (str == null) {
            deserializedObj = {};
        } else {
            deserializedObj = this.deserializeStoredData(str);
        }

        if (this._state.app != null) {
            deserializedObj.app = this._state.app;
        }

        return deserializedObj;
    }

    private saveUserSettings(value) {
        this._state.user.settings = _.extend({}, this._state.user.settings, value);
    }

    private themeUpdateFinish(success, id, name, data) {
        if (success !== true) {
            return false;
        }

        let returnVal = false;

        const userSettings = this._state.user.settings;

        if (userSettings != null && userSettings.themeData != null) {
            userSettings.themeData = appTheme.fillMapObj(userSettings.themeData, this.glob);
            returnVal = true;
        }

        const appSettings = this._state.app.settings;

        if (appSettings != null && appSettings[APP_SETTINGS_DEFAULT_THEME_FIELD] != null) {
            appSettings[APP_SETTINGS_DEFAULT_THEME_FIELD] = appTheme.fillMapObj(
                appSettings[APP_SETTINGS_DEFAULT_THEME_FIELD],
                this.glob
            );
            returnVal = true;
        }

        return returnVal;
    }

    private setSections(domain: string, arr: any[]) {
        var dict: any = {};

        var _arr = arr.slice(0);
        var cur;

        while (_arr.length > 0) {
            cur = _arr.shift();
            _arr = _arr.concat(cur.children);

            dict[cur.id] = cur;
        }

        this._state[domain].sectionsTree = arr;
        this._state[domain].sectionsDict = dict;
    }

    private loadDescriptionUser() {
        var SERVICE_RESPONSE_TEMP = {
            // "sections" is a tree structure for settings sections
            // it's a list of top-level nodes, and each node has "children"
            // field which is a list of nodes itself
            sections: [
                {
                    // "id" is used internally, should be unique for each section
                    id: 'main',
                    // A title, used in presentation
                    name: 'Main',
                    // inner nodes list
                    children: [
                        {
                            id: 'subGroup',
                            name: 'Sub Group',
                            children: [],

                            elements: [
                                {
                                    type: 'label',
                                    text: 'Test Number Parameter'
                                },

                                {
                                    type: 'parameter',
                                    id: 'testNumber'
                                }
                            ]
                        }
                    ],

                    // A list of blocks, rendered when a section is selected
                    elements: [
                        {
                            // Right now only two types of blocks (elements)
                            // are supported: 'label' and 'parameter'.
                            type: 'label',

                            // this is specific to 'label' element and defines displayed text
                            text: 'Application Theme'
                        },

                        {
                            // This renders an edit parameter
                            type: 'parameter',

                            // this is specific to 'parameter' element
                            // and it should match an id of one of settings in "fields"
                            id: 'themeData'
                        }
                    ]
                }
            ],

            // A specification for settings
            fields: {
                // This key and 'id' shoudld match
                themeData: {
                    id: 'themeData',

                    // Platform's JS module, which will be used to render
                    // edit component
                    module: '_common/platform/ts/ThemesListField',

                    _default: null,

                    // this object is passed to edit component,
                    // some of them are configurable, for example here
                    // 'levels' tells ThemesListField to show all theme parameters
                    // for 'application level'
                    options: {
                        levels: ['application']
                    }
                },

                testNumber: {
                    id: 'testNumber',
                    module: '_common/platform/ts/NumberField',
                    _default: 0,
                    options: {}
                }
            }
        };

        this.setSections('user', SERVICE_RESPONSE_TEMP.sections);

        this._state.user.fieldsDict = SERVICE_RESPONSE_TEMP.fields;

        this.actions.userSettingsLoadDescriptionFinish();
    }

    private loadDescriptionUserFinish() {}

    private loadDescriptionApp() {
        if (this._state.app.descriptionLoading) {
            return;
        }

        this._state.app.descriptionLoading = true;

        apiCall<{ settingsdescription: SettingsDescription.APIResponse }>(
            this.actions,
            'appSettings_GetSettingsDescription',
            {}
        )
            .then(({ result: { settingsdescription } }) => {
                this.setSections('app', settingsdescription.sections);

                this._state.app.fieldsDict = settingsdescription.fields;
            })
            .always(() => {
                this.actions.appSettingsGetDescriptionFinish();
            });
    }

    private loadDescriptionAppFinish() {
        this._state.app.descriptionLoading = false;
    }

    private inputTransformSettings(arr) {
        return arr.appSettings;
    }

    private outputTransformSettings(obj) {
        return obj;
    }

    private inputTransformValue(val, key) {
        if (typeof val === 'string' && val.indexOf('<%') === -1) {
            try {
                val = JSON.parse(val);
            } catch (e) {}
        }

        if (key === APP_SETTINGS_DEFAULT_THEME_FIELD && typeof val === 'object') {
            val = appTheme.fillMapObj(val, this.glob);
        }

        return val;
    }

    private outputTransformValue(val, key) {
        if (key === APP_SETTINGS_DEFAULT_THEME_FIELD && typeof val === 'object') {
            val = appTheme.clearMapObj(val);
        }

        if (typeof val !== 'string') {
            val = JSON.stringify(val);
        }

        return val;
    }

    public appSettingsGet(names = [], settings?, forEdit?) {
        if (this._state.app.loading) {
            return;
        }

        this._state.app.loading = true;

        if (settings != null) {
            this._state.app.settings = _.mapObject(settings, _.bind(this.inputTransformValue, this));
        }

        const result = $.Deferred();

        const def1 = apiCall(this.actions, 'appSettings_GetValues', {
            keyList: names,
            runtime: forEdit !== true
        });
        const def2 = apiCall(this.actions, 'workspace_GetDefaultWorkspaces', {
            keyList: []
        });
        const def3 = apiCall(this.actions, 'frontendHelper_GetBackendParam', {});

        $.when
            .apply($, [def1, def2, def3])
            .done(({ result: resp }, respDefaultWorkspaces: any, respBackendParams: any) => {
                const appSettings = (resp as any).appSettings;
                // Handle probably malformed DEFAULT_WORKSPACE_SETTING
                let workspaceDefault = { workspace: {}, workspaceOrder: {} };
                try {
                    workspaceDefault = JSON.parse(appSettings[DEFAULT_WORKSPACE_SETTING]);
                } catch {}
                // update default workspace settings with permitted for current user
                // if workspace/default is defined by cutom backend AppSettings callback
                // the method returns NULL object. Just ignore it
                if (respDefaultWorkspaces.result?.defaultWorkspaces?.length > 0) {
                    const { workspace, workspaceOrder } = workspaceDefault;
                    const permittedWorkspacesIds = Object.keys(workspace).filter((key) =>
                        respDefaultWorkspaces.result.defaultWorkspaces.includes(parseInt(key))
                    );

                    let permittedWorkspaces = {};
                    let permittedWorkspaceOrder = {};
                    permittedWorkspacesIds.forEach((key) => {
                        if (workspace != null && workspace[key] != null) {
                            permittedWorkspaces[key] = workspace[key];
                        }
                        if (workspaceOrder != null && workspaceOrder[key] != null) {
                            permittedWorkspaceOrder[key] = workspaceOrder[key];
                        }
                    });
                    workspaceDefault.workspace = permittedWorkspaces;
                    workspaceDefault.workspaceOrder = permittedWorkspaceOrder;
                }
                resp['appSettings'][DEFAULT_WORKSPACE_SETTING] = JSON.stringify(workspaceDefault);

                this._state.app.settings = _.mapObject(
                    this.inputTransformSettings(resp),
                    _.bind(this.inputTransformValue, this)
                );

                _.each(respBackendParams.result, (el) => {
                    const key = _.keys(el)[0];

                    this._state.app.settings[key] = el[key];
                });

                this.actions.appSettingsGetFinish(this._state.app.settings);

                result.resolve();
            });

        return result;
    }

    private appSettingsGetFinish() {
        this._state.app.loading = false;
    }

    public appSettingsGetDefaultTheme() {
        if (this._state.app.defaultThemeloading) {
            return;
        }

        this._state.app.defaultThemeloading = true;

        apiCall(
            this.actions,
            'getThemeDefault',
            {},
            {
                endPoint: config.getAPIEndpoint() + '/auth'
            }
        )
            .then(({ result: resp }) => {
                return (this._state.app.settings[APP_SETTINGS_DEFAULT_THEME_FIELD] = this.inputTransformValue(
                    resp,
                    APP_SETTINGS_DEFAULT_THEME_FIELD
                ));
            })
            .always(() => {
                this.actions.appSettingsGetDefaultThemeFinish(this._state.app.settings);
            });
    }

    private appSettingsGetDefaultThemeFinish() {
        this._state.app.defaultThemeloading = false;
    }

    private appSettingsSet(values) {
        this._state.app.saving = true;
        this._state.app.errors = {};

        values = _.pick(
            values,
            _.filter(_.keys(values), (key) => {
                return values[key] !== this._state.app.settings[key];
            })
        );

        apiCall<any>(this.actions, 'appSettings_SetValues', {
            appSettings: this.outputTransformSettings(_.mapObject(values, _.bind(this.outputTransformValue, this)))
        })
            .done(({ result: errors }) => {
                if (errors.length === 0) {
                    this._state.app.settings = _.extend(this._state.app.settings, values);

                    this.actions.showNotification_Success('App settings were saved successfully');
                } else {
                    this._state.app.errors = _.reduce(
                        errors,
                        (res, obj: any) => {
                            res[obj.key] = obj.validationError;

                            return res;
                        },
                        {}
                    );

                    this.actions.showNotification_Fail('App settings can not be saved, server validation fails');
                }
            })
            .always(() => {
                this.actions.appSettingsSetFinish(this._state.app.settings);
            });
    }

    private appSettingsTestEmailSend(values) {
        this._state.app.saving = true;
        this._state.app.errors = {};

        const _settings = values || this._state.app.settings;
        const params = {
            mailServer: _settings['Authentication/MailServer'],
            replyEMail: _settings['Authentication/ReplyEmail'],
            authenticate: _settings['Authentication/U1AuthenticateSMTPServer'],
            userName: _settings['Authentication/U2UserName'],
            password: _settings['Authentication/U3UserPassword'],
            smtpPort: _settings['Authentication/U4SMTPPort']
        };

        apiCall<any>(this.actions, 'user_TestSendEmail', params)
            .done((resp) => {
                if (resp.result != null && resp.result.code != null) {
                    this.actions.showNotification_Fail('Test E-mail sending fails');
                } else {
                    this.actions.showNotification_Success('Test E-mail sending is OK');
                }
            })
            .always(() => {
                this.actions.appSettingsSetFinish(this._state.app.settings);
            });
    }

    private appSettingsSetFinish() {
        this._state.app.saving = false;
    }

    public restoreAppSettingsForExport(values) {
        return this.outputTransformSettings(_.mapObject(values, _.bind(this.outputTransformValue, this)));
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const a: any = payload.action;
        const _case = checkAction;

        do {
            if (_case<I.THEME_GET_FINISH>(a, Constants.THEME_GET_FINISH)) {
                this.emitChange();
                break;
            }

            if (_case<I.THEME_UPDATE_FINISH>(a, Constants.THEME_UPDATE_FINISH)) {
                this.emitChange(this.themeUpdateFinish(a.success, a.id, a.name, a.data));
                break;
            }

            if (_case<I.USER_SETTINGS_LOAD_DESCRIPTION>(a, Constants.USER_SETTINGS_LOAD_DESCRIPTION)) {
                this.loadDescriptionUser();
                this.emitChange();
                break;
            }

            if (_case<I.USER_SETTINGS_LOAD_DESCRIPTION_FINISH>(a, Constants.USER_SETTINGS_LOAD_DESCRIPTION_FINISH)) {
                this.loadDescriptionUserFinish();
                this.emitChange();
                break;
            }

            if (_case<I.SAVE_USER_SETTINGS>(a, Constants.SAVE_USER_SETTINGS)) {
                this.saveUserSettings(a.value);
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_GET_DESCRIPTION>(a, Constants.APP_SETTINGS_GET_DESCRIPTION)) {
                this.loadDescriptionApp();
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_GET_DESCRIPTION_FINISH>(a, Constants.APP_SETTINGS_GET_DESCRIPTION_FINISH)) {
                this.loadDescriptionAppFinish();
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_GET>(a, Constants.APP_SETTINGS_GET)) {
                this.emitChange(this.appSettingsGet(a.names, a.settings, a.forEdit));
                break;
            }

            if (_case<I.APP_SETTINGS_GET_FINISH>(a, Constants.APP_SETTINGS_GET_FINISH)) {
                this.appSettingsGetFinish();
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_GET_DEFAULT_THEME>(a, Constants.APP_SETTINGS_GET_DEFAULT_THEME)) {
                this.appSettingsGetDefaultTheme();
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_GET_DEFAULT_THEME_FINISH>(a, Constants.APP_SETTINGS_GET_DEFAULT_THEME_FINISH)) {
                this.appSettingsGetDefaultThemeFinish();
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_SET>(a, Constants.APP_SETTINGS_SET)) {
                this.appSettingsSet(a.values);
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_TEST_EMAIL_SEND>(a, Constants.APP_SETTINGS_TEST_EMAIL_SEND)) {
                this.appSettingsTestEmailSend(a.values);
                this.emitChange();
                break;
            }

            if (_case<I.APP_SETTINGS_SET_FINISH>(a, Constants.APP_SETTINGS_SET_FINISH)) {
                this.appSettingsSetFinish();
                this.emitChange();
                break;
            }
        } while (false);

        return true;
    }
}

// var SERVICE_RESPONSE_TEMP = {
//     "fields": {
//         "AQL/MinCacheTime": {
//             "_default": "3",
//             "id": "AQL/MinCacheTime",
//             "module": "_common/platform/ts/NumberField",
//             "options": {},
//             "validators": [
//                 {
//                     "args": [
//                         3,
//                         86400
//                     ],
//                     "module": "main",
//                     "path": "number.range"
//                 }
//             ]
//         },
//         "Authentication/AUTH_COOKIE_NAME": {
//             "_default": "null",
//             "id": "Authentication/AUTH_COOKIE_NAME",
//             "module": "_common/platform/ts/StringField",
//             "options": {
//                 "readOnly": [
//                     "true"
//                 ]
//             },
//             "validators": []
//         },
//         "Authentication/AUTH_COOKIE_PATH": {
//             "_default": "null",
//             "id": "Authentication/AUTH_COOKIE_PATH",
//             "module": "_common/platform/ts/StringField",
//             "options": {
//                 "readOnly": [
//                     "true"
//                 ]
//             },
//             "validators": []
//         },
//         "Authentication/AdminCanEnterPW": {
//             "_default": "null",
//             "id": "Authentication/AdminCanEnterPW",
//             "module": "_common/platform/ts/BooleanField",
//             "options": {
//                 noTitle: true
//             },
//             "validators": []
//         },
//         "Authentication/MailServer": {
//             "_default": "null",
//             "id": "Authentication/MailServer",
//             "module": "_common/platform/ts/StringField",
//             "options": {},
//             "validators": []
//         },
//         "Authentication/PWCanBeResent": {
//             "_default": "null",
//             "id": "Authentication/PWCanBeResent",
//             "module": "_common/platform/ts/BooleanField",
//             "options": {
//                 noTitle: true
//             },
//             "validators": []
//         },
//         "Authentication/PWMinLength": {
//             "_default": "null",
//             "id": "Authentication/PWMinLength",
//             "module": "_common/platform/ts/NumberField",
//             "options": {},
//             "validators": []
//         },
//         "Authentication/PWMustHaveMixedLetterCase": {
//             "_default": "null",
//             "id": "Authentication/PWMustHaveMixedLetterCase",
//             "module": "_common/platform/ts/BooleanField",
//             "options": {
//                 noTitle: true
//             },
//             "validators": []
//         },
//         "Authentication/PWMustHaveNumbersAndLetters": {
//             "_default": "null",
//             "id": "Authentication/PWMustHaveNumbersAndLetters",
//             "module": "_common/platform/ts/BooleanField",
//             "options": {
//                 noTitle: true
//             },
//             "validators": []
//         },
//         "Authentication/ReplyEmail": {
//             "_default": "null",
//             "id": "Authentication/ReplyEmail",
//             "module": "_common/platform/ts/StringField",
//             "options": {},
//             "validators": []
//         },
//         "Authentication/UseEmailAsLogin": {
//             "_default": "null",
//             "id": "Authentication/UseEmailAsLogin",
//             "module": "_common/platform/ts/BooleanField",
//             "options": {
//                 noTitle: true
//             },
//             "validators": []
//         },
//         "GUI/Title": {
//             "_default": "null",
//             "id": "GUI/Title",
//             "module": "_common/platform/ts/StringField",
//             "options": {},
//             "validators": []
//         },
//         "Mail Templates/LoginEmail": {
//             "_default": "null",
//             "id": "Mail Templates/LoginEmail",
//             "module": "_common/application/ts/CKEditField",
//             "options": {},
//             "validators": []
//         },
//         "Mail Templates/PasswordResetEmail": {
//             "_default": "null",
//             "id": "Mail Templates/PasswordResetEmail",
//             "module": "_common/application/ts/CKEditField",
//             "options": {},
//             "validators": []
//         },
//         "Mail Templates/WelcomeEmail": {
//             "_default": "null",
//             "id": "Mail Templates/WelcomeEmail",
//             "module": "_common/application/ts/CKEditField",
//             "options": {},
//             "validators": []
//         },
//         "Mail Templates/WelcomeNewPWEmail": {
//             "_default": "null",
//             "id": "Mail Templates/WelcomeNewPWEmail",
//             "module": "_common/application/ts/CKEditField",
//             "options": {},
//             "validators": []
//         },
//         "logging": {
//             "_default": {
//                 "logconfiguration": "null"
//             },
//             "directOptions": {
//                 "elements": [
//                     {
//                         "text": "Log Configuration",
//                         "type": "label"
//                     },
//                     {
//                         "id": "logconfiguration",
//                         "type": "parameter"
//                     }
//                 ],
//                 "fieldsDict": {
//                     "logconfiguration": {
//                         "_default": "null",
//                         "id": "logconfiguration",
//                         "module": "_common/platform/ts/SelectField",
//                         "options": {
//                             "display": [
//                                 "ServerNormal",
//                                 "ServerDebug",
//                                 "LocalDebug"
//                             ],
//                             "values": [
//                                 "ServerNormal",
//                                 "ServerDebug",
//                                 "LocalDebug"
//                             ]
//                         },
//                         "validators": []
//                     }
//                 }
//             },
//             "id": "logging",
//             "module": "_common/platform/ts/MultiField",
//             "options": {}
//         },
//         "theme/default": {
//             "_default": "null",
//             "id": "theme/default",
//             "module": "_common/platform/ts/ThemesListField",
//             "options": {
//                 "levels": [
//                     "application"
//                 ]
//             },
//             "validators": []
//         },
//         "workspace/default": {
//             "_default": "null",
//             "id": "workspace/default",
//             "module": "_common/platform/ts/FolderSelectField",
//             "options": {
//                 "mode": "workspace-multiple",
//             },
//             "validators": []
//         }
//     },
//     "sections": [
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "Min Cache Time",
//                     "type": "label"
//                 },
//                 {
//                     "id": "AQL/MinCacheTime",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "aql",
//             "name": "AQL"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "id": "Authentication/UseEmailAsLogin",
//                     "type": "parameter",
//                     "title": "Email as Login"
//                 },
//                 {
//                     "id": "Authentication/PWMustHaveMixedLetterCase",
//                     "type": "parameter",
//                     "title": "Password must have mixed letter case"
//                 },
//                 {
//                     "id": "Authentication/PWCanBeResent",
//                     "type": "parameter",
//                     "title": "Password can be re-sent"
//                 },
//                 {
//                     "id": "Authentication/AdminCanEnterPW",
//                     "type": "parameter",
//                     "title": "Administrator can enter password"
//                 },
//                 {
//                     "id": "Authentication/ReplyEmail",
//                     "type": "parameter",
//                     "title": "Reply Email",
//                     "inlineFixed": 200,
//                     "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
//                 },
//                 {
//                     "id": "Authentication/PWMinLength",
//                     "type": "parameter",
//                     "title": "Password minimal length",
//                     "inlineFixed": 200,
//                     "description": "Passowrd should contain at least specified number of characters"
//                 },
//                 {
//                     "id": "Authentication/MailServer",
//                     "type": "parameter",
//                     "title": "Mail Server",
//                     "inlineFixed": 200,
//                     "description": ""
//                 },
//                 {
//                     "id": "Authentication/AUTH_COOKIE_PATH",
//                     "type": "parameter",
//                     "title": "Cookie Path",
//                     "inlineFixed": 200,
//                     "description": ""
//                 },
//                 {
//                     "id": "Authentication/AUTH_COOKIE_NAME",
//                     "type": "parameter",
//                     "title": "Cookie Name",
//                     "inlineFixed": 200,
//                     "description": ""
//                 }
//             ],
//             "id": "authentication",
//             "name": "Authentication"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "Title",
//                     "type": "label"
//                 },
//                 {
//                     "id": "GUI/Title",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "gui",
//             "name": "GUI"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "New Password",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/WelcomeNewPWEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Welcome Email",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/WelcomeEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Password Reset",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/PasswordResetEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Login Info",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/LoginEmail",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "mailtemplates",
//             "name": "Mail Templates"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "Password Reset",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/PasswordResetEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Login Info",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/LoginEmail",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "mailtemplates",
//             "name": "Mail Templates"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "Welcome Email",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/WelcomeEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Password Reset",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/PasswordResetEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Login Info",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/LoginEmail",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "mailtemplates",
//             "name": "Mail Templates"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "New Password",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/WelcomeNewPWEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Welcome Email",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/WelcomeEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Password Reset",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/PasswordResetEmail",
//                     "type": "parameter"
//                 },
//                 {
//                     "text": "Login Info",
//                     "type": "label"
//                 },
//                 {
//                     "id": "Mail Templates/LoginEmail",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "mailtemplates",
//             "name": "Mail Templates"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "id": "logging",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "logging",
//             "name": "Logging"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "Default",
//                     "type": "label"
//                 },
//                 {
//                     "id": "theme/default",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "theme",
//             "name": "Theme"
//         },
//         {
//             "children": [],
//             "elements": [
//                 {
//                     "text": "Default",
//                     "type": "label"
//                 },
//                 {
//                     "id": "workspace/default",
//                     "type": "parameter"
//                 }
//             ],
//             "id": "workspace",
//             "name": "Workspace"
//         }
//     ]
// };
